export default __webpack_public_path__ + "media/zurb/img/events/soapbox/soapbox-img5-565951cfa8777bc221d4ebf7b04549d8.png";